import classnames from 'classnames/bind'

// Components
import LiveDealsSection from './LiveDealsSection'
import ProductList from './ProductList'

// Styles
import styles from './style.module.scss'

const cx = classnames.bind(styles)

type MallLandingPageProps = {
  categoryListData: any
  gtmItemEventParams: {
    itemListName: string
    itemListId?: string
  }
}

const MallLandingPage = ({ categoryListData, gtmItemEventParams }: MallLandingPageProps) => {
  return (
    <div className={cx('container')}>
      <div className={cx('mall-landing-page')}>
        <LiveDealsSection />
        <ProductList categoryListData={categoryListData} gtmItemEventParams={gtmItemEventParams} />
      </div>
    </div>
  )
}

export default MallLandingPage
